import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { IFileDownload } from 'src/app/interface/dto';
import { ExamScheduleService } from 'src/app/services/exam-schedule-service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-exam-script-report',
  templateUrl: './exam-script-report.component.html',
  styleUrls: ['./exam-script-report.component.scss']
})
export class ExamScriptReportComponent implements OnInit {
  exportedFile: IFileDownload = {
    fileName: '',
    size: 0,
    extension: '',
    file: undefined
  };
  constructor(private snackBar: SnackbarService,private examSchService: ExamScheduleService,
    private popoverRef: PopoverRef<ExamScriptReportComponent>,) { }

 async ngOnInit() {
  await this.examSchService.getExamScheduleScript().then((s: IFileDownload) => {
    this.snackBar.success('Report Successfull' );
    this.exportedFile = s;

    })
  }
  close() {
    this.popoverRef.close();
  }

}
